module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-offer-price-tooltip-graph.1666ba42.svg";